/**
 * Unified Inline Loading State Component
 * Small loading indicator for inline use (buttons, dropdowns, etc.)
 */

import React from 'react';
import {AppText} from '../ui/Typography';

interface InlineLoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  showMessage?: boolean;
  className?: string;
}

export const InlineLoadingState: React.FC<InlineLoadingStateProps> = ({
  message = 'جاري التحميل...',
  size = 'md',
  showMessage = true,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-5 h-5 border-2',
    lg: 'w-6 h-6 border-[3px]'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div
        className={`${sizeClasses[size]} border-brand-500 border-t-transparent rounded-full animate-spin`}
      ></div>
      {showMessage && (
        <AppText className={`text-gray-600 ${textSizes[size]}`}>{message}</AppText>
      )}
    </div>
  );
};

export default InlineLoadingState;


